import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AdminApp } from "./admin/AdminApp";
import { EmbedApp } from "./embed/EmbedApp";
import { Landing } from "./Landing";
import "./styles.css";

const path = window.location.pathname.replace(/\/+$/, "") || "/";
const app = path === "/embed" ? <EmbedApp /> : path === "/admin" ? <AdminApp /> : <Landing />;

createRoot(document.getElementById("root")!).render(<StrictMode>{app}</StrictMode>);
